export default "__VITE_ASSET__DknN1yPE__"